import api from 'api'
import { PositionId, WorkerRequirementId } from './types'

type UnassignRequirementFromPositionParams = {
  positionId: PositionId
  requirementId: WorkerRequirementId
}

export async function unassignRequirementFromPosition({
  positionId,
  requirementId,
}: UnassignRequirementFromPositionParams): Promise<void> {
  await api.delete(
    `/admin/positions/${positionId}/requirements/${requirementId}`
  )
}
